import { IsNotEmpty } from 'class-validator';

export class OrderLineUpdateDto {
  /**
   * Barcode / EAN code is the more specific denominator,
   * for our products it would mean, it includes the size (Cloudstratus 1 Navy | Dust W 8.5)
   * @example '7630040540773'
   */
  @IsNotEmpty()
  public barcode: string;

  /**
   * updated amount for the item
   * * @example 10
   */
  @IsNotEmpty()
  public quantity: number;
}
